<div class="top-bar">
    <div class="company-logo-small"></div>
</div>
<app-main-menu></app-main-menu>
<div class="menu-accent"></div>
